import initialState from './initialState';
import {
  SEND_TEST_EMAIL_DELIVERY,
  SEND_TEST_EMAIL_DELIVERY_DONE,
  SEND_TEST_EMAIL_DELIVERY_ERROR,
  SEND_TEST_EMAIL_DELIVERY_LOADING,
  SEND_TEST_EMAIL_DELIVERY_SUCCESS
} from '../actions/actionTypes';

// Create your Reducer here...
const reducerSendTestEmailDelivery = (state = initialState, action) => {
  switch (action.type) {
    case SEND_TEST_EMAIL_DELIVERY_LOADING:
      return {
        ...state,
        loading: true,
        emails: null,
        errors: null,
        error: null
      };
    case SEND_TEST_EMAIL_DELIVERY_SUCCESS:
      return {
        ...state,
        emails: action.emails.success_users,
        errors: action.emails.errors,
        error: null
      };
    case SEND_TEST_EMAIL_DELIVERY_ERROR:
      return {
        ...state,
        emails: null,
        errors: null,
        error: action.error
      };
    case SEND_TEST_EMAIL_DELIVERY_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(SEND_TEST_EMAIL_DELIVERY)) {
    return reducerSendTestEmailDelivery(state, action);
  } else {
    return state;
  }
};
